import { library } from '@fortawesome/fontawesome-svg-core';

// ✅ Import all icons from free sets
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

// ✅ Add all to the FontAwesome library
library.add(fas, far, fab);
